import { useNavigate, useSearchParams } from 'react-router-dom';
import { ResetPasswordPage } from '@practium/features/auth';

export const ResetPasswordPageClient = () => {
	const navigate = useNavigate();
	const [searchParams] = useSearchParams();
	const token = searchParams.get('token');

	return (
		<ResetPasswordPage
			token={token}
			onSuccess={() => navigate('/login')}
			onRequestNewLink={() => navigate('/forgot-password')}
		/>
	);
};
